import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import PackerRefundCalculatorItem from './packerRefundCalculatorItem';
import utils from '../../utils/utils';
import PAYMENT_REFUND_PAYER from '../../components/constants/paymentRefundPayer';

const PackerRefundCalculator = ({ orderItem, onSuccess }) => {
  const quantity = orderItem.fulfilledQuantity !== null ? orderItem.fulfilledQuantity : orderItem.quantity;

  const [refundOrderItems, setRefundOrderItems] = useState(
    Array(quantity)
      .fill(null)
      .map(() => ({
        // need this bc array.fill fills array with references to same object
        orderItem,
        amount: 0,
        orderId: orderItem.orderId,
        payer: PAYMENT_REFUND_PAYER.producer,
      }))
  );

  const refundSum = utils.getRoundedPrice(refundOrderItems.reduce((sum, value) => sum + value.amount, 0));

  const items = Array(quantity).fill(orderItem);

  return (
    <div>
      <h2>
        <FormattedMessage id={'packer.refund.calculator.header'} />
      </h2>
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">
              <FormattedMessage id={'refund.create.order.item.calculation.table.name'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'refund.create.order.item.calculation.table.enter.weight'} />
            </th>
            <th scope="col">
              <FormattedMessage id={'refund.create.order.item.calculation.table.result'} />
            </th>
          </tr>
        </thead>

        <tbody>
          {items.map((oi, oiIndex) => {
            return (
              <PackerRefundCalculatorItem
                key={oiIndex}
                orderItem={oi}
                onRefundAmountChange={(newRefundAmount) => {
                  const newResult = [...refundOrderItems];
                  newResult[oiIndex].amount = newRefundAmount;
                  setRefundOrderItems(newResult);
                }}
              />
            );
          })}
        </tbody>
      </table>

      <h4 className="m-b-6 text-right">
        <FormattedMessage id={'refund.create.order.item.calculation.total.refund'} />: {refundSum}€
      </h4>

      <div className="text-center">
        <button className="btn btn-primary" onClick={() => onSuccess(refundOrderItems.filter((roi) => roi.amount > 0))}>
          <FormattedMessage id={'packer.refund.calculator.cta'} />
        </button>
      </div>
    </div>
  );
};

PackerRefundCalculator.propTypes = {
  orderItem: PropTypes.object.isRequired,
};

PackerRefundCalculator.defaultProps = {};

export default injectIntl(PackerRefundCalculator);
